import { combineReducers, configureStore, Reducer } from '@reduxjs/toolkit';
import locationReducer from './locationSlice';
import networkReducer from './networkSlice';
import prefsReducer from './prefsSlice';
import { persistReducer, persistStore } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';
import localStorage from 'redux-persist/es/storage';
import bookmarkReducer from './bookmarksSlice';
import avatarReducer from './avatarSlice';

const rootPersistConfig = {
	key: 'root',
	storage: storageSession,
	stateReconciler: autoMergeLevel2,
};

const prefsPersistConfig = {
	key: 'prefs',
	storage: localStorage,
	stateReconciler: autoMergeLevel2,
};

const bookmarkPersistConfig = {
	key: 'bookmarks',
	storage: localStorage,
	stateReconciler: autoMergeLevel2,
};

const avatarPersistConfig = {
	key: 'avatar',
	storage: localStorage,
	stateReconciler: autoMergeLevel2,
};

const rootReducer = combineReducers({
	location: locationReducer,
	network: networkReducer,
	avatar: persistReducer(avatarPersistConfig, avatarReducer as Reducer),
	prefs: persistReducer(prefsPersistConfig, prefsReducer as Reducer),
	bookmarks: persistReducer(
		bookmarkPersistConfig,
		bookmarkReducer as Reducer,
	),
});

const persistedReducer = persistReducer(
	rootPersistConfig,
	rootReducer as Reducer,
);

const store = configureStore({
	reducer: persistedReducer,
	devTools: process.env.NODE_ENV !== 'production',
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppState = RootState;
export type AppDispatch = typeof store.dispatch;
export const persistor = persistStore(store);
export default store;
